import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AmazonMWSObjectDataset } from 'app/model/dataset/amazon-mws.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonMWSObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class AmazonMWSObjectDatasetAdapter extends TabularTypeDatasetAdapter<AmazonMWSObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AmazonMWSObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(AmazonMWSObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AmazonMWSObjectDataset): Promise<AmazonMWSObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, AmazonMWSObjectDataset.MODEL);
    }
}
